import moment from "moment";
import React, { useRef, useState } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import ReactHtmlParser from "react-html-parser";

export const PrintInvoice = (props) => {
  const [open, setOpen] = useState(false);
  let phone_numbers = [];
  if (props?.merchantName?.contact_detail?.length)
    props.merchantName.contact_detail.map((e) => {
      phone_numbers.push(e?.country_code + e?.mobile_no);
    });

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => setOpen(true)}
      >
        <Image
          src={require("../../../assets/images/Icon/invoice.png")}
          alt="Invoice"
          title="Invoice"
          fluid
          style={{ width: "20px" }}
        />
      </Button>
      <Modal show={open} onHide={() => setOpen(false)} centered>
        <Modal.Header className="py-0 pt-3 border-0" closeButton>
          <Modal.Title className="f24-700">Print Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="border px-4 py-2"
            style={{
              maxWidth: "500px",
              borderColor: "black",
            }}
            ref={componentRef}
          >
            <div className="text-center f16-700 my-2 ">
              <Image
                src={require("../../../assets/images/kot.png")}
                alt="amealio"
                title="amealio"
                fluid
                width="120"
              />
            </div>
            <div className="text-center f14-700 mt-2 ">Invoice</div>
            <div className="text-center f14-700 mt-2 my-2 ">
              {props?.merchantName?.restaurant_name || ""}
            </div>
            <div className="text-center text-break f14-700 mt-2 my-2 ">
              {props?.merchantName?.restaurant_address || ""}
            </div>
            <div className="text-center f14-700 mt-2 my-2 ">
              Mob: {phone_numbers?.toString() || ""}
            </div>
            <div className="text-center f14-700 mt-2 my-2 ">
              Restaurant GSTIN: {props?.merchantName?.gst_number || ""}
            </div>
            <div className="text-center f14-700 mt-2 my-2 ">
              Restaurant FSSAI: {props?.merchantName?.fssai_code || ""}
            </div>
            <hr />
            <div className="d-flex">
              <div className=" f14-700 py-1 mr-2">Order Date:</div>
              <div className=" f14-700 py-1">
                {moment(
                  new Date(
                    (props?.data?.order_type === 0 ||
                      props?.data?.order_type === 1) &&
                    !props?.data?.now
                      ? props?.data?.later_date
                      : props?.data?.createdAt
                  )
                ).format("DD MMM YYYY, HH:mm A")}
              </div>
            </div>
            <hr />
            <div className="d-flex">
              <div className="f14-700 py-1 mr-2">ORDER ID:</div>
              <div className="f14-700 py-1">
                {props?.data?.order_id || ""}
              </div>
            </div>
            <div className="pr-3 pl-3">
              <div
                className="row p-2 mt-2 mb-2 f14-500"
                style={{
                  borderTop: "1px dashed black",
                  borderBottom: "1px dashed black",
                }}
              >
                <div className="col-4 p-0">Item</div>
                <div className="col-2 ">Quantity</div>
                <div className="col-3 ">Rate</div>
                <div className="col-3 ">Amount</div>
              </div>
              {props?.data?.order_items.map((item) => {
                return (
                  <div className="row p-2 border-bottom">
                    <div className="col-4 p-0">
                      <div className="f14-500">{item?.item?.name}</div>
                    </div>
                    <div className="col-2 f14-500">{item?.quantity}</div>
                    <div className="col-3 f14-500">
                      {" "}
                      ₹ {item?.size?.price || ""}
                    </div>
                    <div className="col-3 f14-500">
                      ₹{" "}
                      {(
                        parseFloat(item?.size?.price) * parseInt(item?.quantity)
                      ).toFixed(2) || ""}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="row f14-700 pr-4">
              <div className="col-4"></div>
              <div className="col-8 px-4 py-2">
                <ClassificationOfCharges data={props.data.gstAmount} />
                <ClassificationOfCharges data={props.data.surCharges} />
                {props?.data?.tip?.amount ? (
                  <div className="row">
                    <div className="col-8">Tip</div>
                    <div className="col-4">
                      ₹ {parseFloat(props?.data?.tip?.amount)?.toFixed(2)}
                    </div>
                  </div>
                ) : null}
                {props?.data?.donation?.amount ? (
                  <div className="row">
                    <div className="col-8">Donation</div>
                    <div className="col-4">
                      ₹ {parseFloat(props?.data?.donation?.amount)?.toFixed(2)}
                    </div>
                  </div>
                ) : null}
                {props?.data?.discount?.amount ? (
                  <div className="row">
                    <div className="col-8">Discount</div>
                    <div className="col-4">
                      ₹ {parseFloat(props?.data?.discount?.amount)?.toFixed(2)}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className="row f14-700 pr-4 mb-4 align-items-center"
              style={{ backgroundColor: "#80808061" }}
            >
              <div className="col-4"></div>
              <div className="col-8 px-4 py-2">
                <div className="row">
                  <div className="col-8">Total</div>
                  <div className="col-4">
                    ₹ {parseFloat(props.data?.total_amount)?.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 f14-500 text-center">
              <div>Thank You! Glad to serve you!</div>
              <div>Kindly rate and review us on Amealio</div>
            </div>
          </div>
          <div className="d-flex align-items-center pt-4">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              style={{ border: "2px solid #ee3a23" }}
              className="btn-lg mr-4 px-5"
              // onClick={(e) => props.next()}
              onClick={handlePrint}
            >
              Print
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const ClassificationOfCharges = ({ data }) => {
  let arrayObj = [];

  if (Array.isArray(data)) {
    for (const obj of data) {
      arrayObj.push({
        name: obj.split("-")[0],
        value: data[obj],
      });
    }
  } else {
    for (const obj in data) {
      arrayObj.push({
        name: obj.split("-")[0],
        value: data[obj],
      });
    }
  }
  return (
    <>
      {arrayObj?.length
        ? arrayObj.map((ele) => {
            return (
              <div className="row">
                <div className="col-8">{ele?.name || ""}</div>
                <div className="col-4">
                  ₹ {Number(ele?.value || 0).toFixed(2)}
                </div>
              </div>
            );
          })
        : null}
    </>
  );
};
